module.exports = __webpack_public_path__ + "img/camp03_open.025e9859.png";